<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="#4d48f9" dark flat>
                <v-toolbar-title>Şifremi unuttum</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <v-form
                  id="check-login-form"
                  ref="form"
                  v-model="valid"
                  lazy-validation
                  @submit.prevent="passwordForgot"
                >
                  <v-text-field
                    v-model="userData.email"
                    name="email"
                    prepend-icon="person"
                    :rules="emailRules"
                    label="Email"
                    required
                    type="text"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  type="submit"
                  color="#4d48f9"
                  form="check-login-form"
                  style="text-transform: none !important; color: white;"
                >
                  Gönder
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <v-dialog v-model="dialog" max-width="600">
          <v-card>
            <v-card-title class="headline">
              Lütfen alanları kontrol edin
            </v-card-title>

            <v-card-text>
              <ul>
                <li v-for="fruit in this.errorList" :key="fruit">
                  {{ fruit }}
                </li>
              </ul>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'
import VueJwtDecode from 'vue-jwt-decode'
import utf8 from 'utf8'
import axios from 'axios'

export default {
  name: 'ForgotPassword',
  data: () => ({
    valid: true,
    userData: {
      email: '',
    },
    emailRules: [
      (v) => !!v || 'E-posta alanı zorunludur.',
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        'Lütfen geçerli bir mail adresi giriniz.',
    ],
    errorList: [],
    dialog: false,
  }),
  methods: {
    ...mapActions(['forgotPassword']),
    passwordForgot() {
      if (this.$refs.form.validate()) {
        this.snackbar = true
        this.forgotPassword(this.userData)
        .then((response) => {
          if (response.data.processStatus == 'Success') {
            alert('Şifreniz mail adresinize gönderilmiştir')
            this.$router.push('/')
          } else {
            alert(response.data.friendlyMessage.message)
          }
        })
        .catch((err) => {
          if (err.response.data) {
            const errorKey = err.response.data.friendlyMessage.message
            if (errorKey == 'user_not_found') {
              alert('Kayıtlı mail adresi bulunamamaktadır.')
            }
          }
        })
      } else {
        var errors = []
        var x = document.getElementsByClassName('v-messages__message')
        for (var i = 0; i < x.length; i++) errors.push(x[i].innerHTML)

        this.errorList = errors

        this.dialog = true
      }
    },
  },
}
</script>
